<template>
  <div>
    <div class="card-header">
      <div class="row accordion-header">
        <div
          :id="headingId"
          class="accordion-header-icon-container"
          :class="{
            'col-md-10 col-sm-12 p-0': $slots['actions'],
            'col-md-12 p-0': !$slots['actions'],
          }"
          data-toggle="collapse"
          :data-target="'#' + id"
          :aria-controls="id"
          :aria-expanded="computedExpanded"
          @click="beforeExpand"
        >
          <div class="d-flex justify-content-start align-items-center">
            <div class="pr-4">
              <div
                class="icon-section justify-content-center align-self-center"
                :class="{ 'header-icon': !hideIcon }"
              />
            </div>
            <div class="flex-fill">
              <slot name="header" />
            </div>
          </div>
        </div>
        <div
          v-if="$slots['actions']"
          class="col-md-2 col-sm-12 p-0 d-flex justify-content-end"
        >
          <slot name="actions" />
        </div>
      </div>

      <div
        :id="id"
        :aria-labelledby="headingId"
        :class="'collapse' + show"
        :data-parent="parentId"
      >
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowCardItem',
  meta: {
    description: 'RowCardItem, hijo del RowCard',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  computed: {
    show() {
      return !this.disabled && this.expanded === true ? ' show' : '';
    },
    headingId() {
      return `${this.id}Heading`;
    },
    parentId() {
      return `#${this.$parent.id}`;
    },
    computedExpanded() {
      return !this.disabled && this.expanded;
    },
  },
  props: {
    id: {
      type: String,
      required: true,
      meta: {
        description: 'Id del Componente padre',
        example: 'idRowCard',
      },
    },
    expanded: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Opción para expandir el componente',
        example: 'true',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      },
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
      meta: {
        description: 'Permite esconder el icono',
        example: 'true',
      },
    },
  },
  methods: {
    beforeExpand() {
      this.$emit('before-expand');
    },
    collapseItem() {
      document.querySelector('[id*="' + this.headingId + '"]').click();
    },
  },
};
</script>

<style scoped>
.card-header {
  padding: 12px;
  cursor: pointer;
  border-bottom: none;
  background-color: white;
}

.card-header .accordion-header {
  border-radius: 5px;
  padding: 12px;
  border: 12px solid #f4f6f3;
}

.card-header .accordion-header-icon-container[aria-expanded='true'] {
  background: #fff;
}

.title-disabled {
  color: rgb(84, 88, 92) !important;
}
.card-header .accordion-header-icon-container .icon-section {
  height: 31px;
  width: 31px;
}

.card-header .accordion-header-icon-container .header-icon:before {
  font-family: 'Font Awesome 5 Pro';
  content: '\f054';
  font-size: 21px;
  font-weight: 900;
  color: #2db782;
}
.card-header .accordion-header .header-icon {
  text-align: center;
  border-radius: 100%;
  border: 1px solid #2db782;
}
.card-header
  .accordion-header-icon-container[aria-expanded='true']
  .header-icon {
  border: 1px solid #ff7058;
}

.card-header
  .accordion-header-icon-container[aria-expanded='true']
  .header-icon:before {
  font-family: 'Font Awesome 5 Pro';
  content: '\f078';
  color: #ff7058;
}
</style>
